import { render, staticRenderFns } from "./ManageBanners.vue?vue&type=template&id=2db9876d&scoped=true"
import script from "./ManageBanners.vue?vue&type=script&lang=js"
export * from "./ManageBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db9876d",
  null
  
)

export default component.exports